import React from "react";
import { AnalyticsTimeRangeTemplate } from "themes/administration/analytics/components";

function AnalyticsTimeRange(props) {
    return <AnalyticsTimeRangeTemplate {...props} />;
}

export default AnalyticsTimeRange;
